export const getCustomGlowShader = (THREE: any) => {
  return {
    uniforms: {
      ...THREE.UniformsLib.fog,
      baseColor: { value: new THREE.Color(0xffffff) },
      emissiveColor: { value: new THREE.Color(0x000000) },
      emissiveIntensity: { value: 1.0 },
      opacity: { value: 1.0 },
    },
    vertexShader: `
      varying vec3 vNormal;
      varying vec3 vViewPosition;
      varying float vFogDepth;

      void main() {
        vNormal = normalize( normalMatrix * normal );
        vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
        vViewPosition = -mvPosition.xyz;
        vFogDepth = -mvPosition.z;
        gl_Position = projectionMatrix * mvPosition;
      }
    `,
    fragmentShader: `
      uniform vec3 baseColor;
      uniform vec3 emissiveColor;
      uniform float emissiveIntensity;
      uniform float opacity;
      
      uniform vec3 fogColor;
      uniform float fogNear;
      uniform float fogFar;

      varying vec3 vNormal;
      varying vec3 vViewPosition;
      varying float vFogDepth;

      void main() {
        // Calculate final emissive color, clamping each component to 1.0
        vec3 finalEmissive = min(emissiveColor * emissiveIntensity, vec3(1.0));

        // Combine base color and clamped emissive color
        vec3 finalColor = baseColor + finalEmissive;

        // Apply fog
        float fogFactor = smoothstep(fogNear, fogFar, vFogDepth);
        vec3 fogAppliedColor = mix(finalColor, fogColor, fogFactor);

        gl_FragColor = vec4(fogAppliedColor, opacity);
      }
    `,
  }
}
